import { render } from "./Golf.vue?vue&type=template&id=62151240"
import script from "./Golf.vue?vue&type=script&lang=js"
export * from "./Golf.vue?vue&type=script&lang=js"

import "./Golf.vue?vue&type=style&index=0&id=62151240&lang=css"
script.render = render

export default script